package org.gymly.ui.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.CalendarMonth
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.gymly.theme.AdminColors
import org.gymly.util.AdminDateOutputFormat
import org.gymly.util.formatDateForOutput
import org.gymly.util.parseFlexibleDateToIso

/**
 * Ancho estándar para filtros Desde/Hasta (fecha ISO + icono de calendario).
 * 150.dp recorta el último dígito; 180.dp deja ver `YYYY-MM-DD` completo.
 */
val AdminDateFieldFilterWidth = 180.dp

/**
 * Campo de fecha admin: se puede escribir (DD/MM/AAAA o AAAA-MM-DD)
 * o elegir con el calendario. Al confirmar el calendario emite [outputFormat].
 */
@Composable
fun AdminDateField(
    value: String,
    onValueChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    label: String? = null,
    placeholder: String = "DD-MM-AAAA",
    enabled: Boolean = true,
    outputFormat: AdminDateOutputFormat = AdminDateOutputFormat.ISO,
    singleLine: Boolean = true,
    useFloatingLabel: Boolean = false,
) {
    var showPicker by remember { mutableStateOf(false) }

    Column(modifier) {
        if (label != null && !useFloatingLabel) {
            Text(label, color = AdminColors.TextMuted, fontSize = 12.sp)
            Spacer(Modifier.height(4.dp))
        }
        OutlinedTextField(
            value = value,
            onValueChange = onValueChange,
            modifier = Modifier.fillMaxWidth(),
            enabled = enabled,
            singleLine = singleLine,
            label = if (useFloatingLabel && label != null) {
                { Text(label) }
            } else {
                null
            },
            placeholder = { Text(placeholder, color = AdminColors.TextMuted) },
            trailingIcon = {
                IconButton(
                    onClick = { if (enabled) showPicker = true },
                    enabled = enabled,
                ) {
                    Icon(
                        Icons.Outlined.CalendarMonth,
                        contentDescription = "Abrir calendario",
                        tint = if (enabled) AdminColors.Primary else AdminColors.TextMuted,
                    )
                }
            },
            shape = RoundedCornerShape(10.dp),
            colors = OutlinedTextFieldDefaults.colors(
                focusedBorderColor = AdminColors.Primary,
                unfocusedBorderColor = AdminColors.Outline,
            ),
        )
    }

    if (showPicker) {
        IsoCalendarDialog(
            initialIso = parseFlexibleDateToIso(value),
            onDismiss = { showPicker = false },
            onConfirm = { iso ->
                onValueChange(formatDateForOutput(iso, outputFormat))
                showPicker = false
            },
            accent = AdminColors.Primary,
        )
    }
}

/** Normaliza el valor del campo a ISO antes de enviar al API (acepta DD/MM o ISO). */
fun resolveAdminDateIso(raw: String): String? = parseFlexibleDateToIso(raw)
